import { useQuery } from "@tanstack/react-query";
import { fetchRebalancePreview, type PreviewQuery } from "../lib/api";
import { queryKeys } from "../lib/queryKeys";

export function useRebalancePreview(query: PreviewQuery) {
	return useQuery({
		queryKey: queryKeys.rebalancePreview(query),
		queryFn: () => fetchRebalancePreview(query),
	});
}
